export enum DataValidationError {
  DATA_IS_TOO_SHORT = "{{constraint1}}文字以上必要です",
  DATA_IS_TOO_LONG = "{{constraint1}}文字までです",
  DATA_IS_EMPTY = "未入力です",
  DATA_IS_INVALID = "不正です",
}
